export interface FunctionGroupFilterType {
  selectedFunctionGroups: server.dto.FunctionGroups[]
}

export const getSortedFunctionGroups = (filter: FunctionGroupFilterType) => {
  const order: server.dto.FunctionGroups[] = [
    "artist", "venue", "promoter"
  ];
  return [...filter.selectedFunctionGroups]
    .sort((a, b) => {
      const indexA = order.findIndex(value => value === a);
      const indexB = order.findIndex(value => value === b);
      return indexA - indexB;
    });
};

export const enabledFunctionGroups = site.currentEnvironment ? Object.values(site.currentEnvironment.functionGroups)
  .filter(fg => fg.enabled && fg.key !== "hotel")
  .map(fg => fg.key) : [];

export const getLabel = (functionGroup: server.dto.FunctionGroups) => {
  return site.currentEnvironment.functionGroups[functionGroup]?.singular;
};

export const initialFunctionGroupFilter: FunctionGroupFilterType = {
  selectedFunctionGroups: []
};
